import React from 'react';

const ErrorBox = (props: any) => {
    return (
        <div style={{ 
            backgroundColor: '#fff8e0',
            borderColor: '#ff5e5e',
            borderWidth: 1,
            borderStyle: 'solid',
            margin: 0,
            paddingTop: '0.75rem',
            paddingBottom: '0.75rem',
            paddingLeft: '1.25rem',
            paddingRight: '1.25rem',
            marginBottom: '1rem',
            ...props.style,
        }}>
            {props.children}
        </div>
    );
}

export default ErrorBox;